import PropTypes from 'prop-types';
import { getGuidLabel } from 'customer-data-objects/property/knownGuidUtils';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyKnownGuid = props => {
  const propertyValue = usePropertyValue();
  const {
    className,
    placeholder
  } = props;
  return /*#__PURE__*/_jsx("span", Object.assign({
    className: className
  }, getDataAttributes(props), {
    children: propertyValue ? getGuidLabel(propertyValue) : placeholder
  }));
};
FormattedPropertyKnownGuid.displayName = 'FormattedPropertyKnownGuid';
FormattedPropertyKnownGuid.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.node
};
export default FormattedPropertyKnownGuid;